const PdfIcon = () => {
    return (
        <i className="fa fa-file-pdf" style={{ fontSize: 16, color: "#de3f0f" }} />
    )
}

export default PdfIcon;